import type { FetchFunction } from '#layers/base/public';
import { joinURL } from 'ufo';
import { isPromiseResultRejected } from '#layers/base/public';

interface FileHooksOptions {
	/** Transport bound to the scope (system or workspace) that owns the files. */
	fetch: FetchFunction;
	/** Assets endpoint relative to the transport's base URL. */
	assetsEndpoint: string;
}

/**
 * Deletes a file from the assets endpoint
 */
async function deleteFile({ fetch, assetsEndpoint }: FileHooksOptions, id: string) {
	return fetch(joinURL(assetsEndpoint, id), { method: 'DELETE' });
}

export function createFileHooks(options: FileHooksOptions) {
	return {
		async delete({ key }: { key: string | number }) {
			await deleteFile(options, key as string);
		},
		async deleteMany({ keys }: { keys: Array<string | number> }) {
			const results = await Promise.allSettled(keys.map((id) => deleteFile(options, id as string)));

			if (results.some((result) => isPromiseResultRejected(result))) {
				throw new Error(`Failed to delete files ${results.map((_, index) => keys[index]).join(', ')} from storage.`);
			}
		},
	};
}
